<template>
  <div class="send-pre-request col-11 col-sm-8 col-md-6 col-lg-4 mx-auto mt-5">
    <p>申込みを受け付けました。</p>
    <p>担当者から後ほど電話でご連絡致します。</p>
  </div>
</template>